import * as types from './types';
import { loading } from 'State/actions';

export const setSelectedSites = sites => {
  return {
    type: types.RECEIPTS_COLLECTIONS_REPORT_SET_SELECTED_SITES,
    payload: sites,
  };
};

export const getReport = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.RECEIPTS_COLLECTIONS_REPORT_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Reports/ReceiptsAndCollections',
        data
      );

      dispatch({
        type: types.RECEIPTS_COLLECTIONS_REPORT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.RECEIPTS_COLLECTIONS_REPORT_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.RECEIPTS_COLLECTIONS_REPORT_LOADING, false));
  };
};

export const clearReport = () => {
  return dispatch => {
    dispatch({ type: types.RECIEPTS_COLLECTIONS_REPORT_CLEAR_REPORT });
  };
};



// WEBPACK FOOTER //
// ./src/pages/receiptsandcollections/state/report/actions.js